// #EXTINF:27,
// #EXT-X-TILES:RESOLUTION=312x176,LAYOUT=3x3,DURATION=3
// Thumbnail_000000003.jpg
// #EXTINF:8,
// #EXT-X-TILES:RESOLUTION=312x176,LAYOUT=3x3,DURATION=3
// Thumbnail_000000004.jpg
// #EXT-X-ENDLIST

export const parseImageStreamManifest = (manifest, baseUrl) => {
  const lines = manifest.split('\n')
  let lineIndex = 0
  const segments = []
  let segmentIndex = -1
  const segment = {}
  const result = { segments }

  for (; lineIndex < lines.length; ++lineIndex) {
    const line = lines[lineIndex]
    if (line.startsWith('#EXTINF:')) {
      break
    }
  }

  for (; lineIndex < lines.length; ++lineIndex) {
    const line = lines[lineIndex]
    if (line.startsWith('#EXTINF:')) {
      const [, totalDuration] = line.match(/#EXTINF:(\d+)/)
      segmentIndex += 1
      segments[segmentIndex] = {}
      if (segmentIndex === 0) {
        result.segmentDuration = Number.parseInt(totalDuration, 10)
      }
    } else if (line.startsWith('#EXT-X-TILES:')) {
      if (segmentIndex === 0) {
        const [, attributes] = line.match(/#EXT-X-TILES:(.*)$/)
        attributes.split(',').forEach((item) => {
          const [key, value] = item.split('=')
          segment[key.toLowerCase()] = value
        })
      }
    } else if (!line.startsWith('#')) {
      segments[segmentIndex].uri = `${baseUrl}/${line}`
    } else if (line === '#EXT-X-ENDLIST') {
      break
    }
  }

  if (segments.length) {
    result.imageDuration = Number.parseInt(segment.duration, 10)
    const [columns, rows] = segment.layout.split('x')
    result.layout = {
      columns: Number.parseInt(columns, 10),
      rows: Number.parseInt(rows, 10),
    }
    const [width, height] = segment.resolution.split('x')
    result.resolution = {
      width: Number.parseInt(width, 10),
      height: Number.parseInt(height, 10),
    }
  }

  return result
}
